module.exports = {"632324100":"优干宁镇","632324101":"宁木特镇","632324201":"多松乡","632324202":"赛尔龙乡","632324203":"柯生乡","632324204":"托叶玛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632324.json
// module id = 3140
// module chunks = 0